import { CmsLink } from '../../cmsTypes'
import { CroppedImage } from '../../cmsTypes'

// IsArray = true Max=8
export class HeaderCarouselPropsApi {
    // Required=true
    /**
     * Background image for the slide
     */
    slideImage: CroppedImage

    // Heading tag for slide
    heading?: string

    // Main title for slide
    title?: string

    // Sub title for slide
    subTitle?: string

    // The button link
    link?: CmsLink
}
